(function() {
    angular
        .module("app")
        .controller("PreviewMessageModalController", PreviewMessageModalController)

    PreviewMessageModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "previewImage"
    ]

    function PreviewMessageModalController(
        $scope,
        $uibModalInstance,
        previewImage
    ){
        "use strict"

        $scope.image_url = previewImage.image_url

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
